import { MenuItem, Stack } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Action Item component.
 *
 * @author Mikhail Siutsou
 * @function ActionItem
 * @category components
 * @param {ActionItemProps} props Action Item.
 * @return {FC} Action Item component.
 */
var ActionItem = function ActionItem(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      onClick = _ref.onClick,
      handleToggle = _ref.handleToggle,
      disabled = _ref.disabled,
      rightIcon = _ref.rightIcon;

  /**
   * handle click menu item.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */
  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }

    if (handleToggle) {
      handleToggle();
    }
  };

  return /*#__PURE__*/_jsx(MenuItem, {
    onClick: handleClick,
    disabled: disabled,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 1,
      direction: "row",
      alignItems: "center",
      flexWrap: "nowrap",
      children: [icon && icon, /*#__PURE__*/_jsx("span", {
        children: title
      }), rightIcon && rightIcon]
    })
  });
};

export { ActionItem };